const masterchefv2 = require("./masterchef_v2");

module.exports = {
  UNIV2_ROUTER_ADDRESS: "0x1b02da8cb0d097eb8d57a175b88c7d8b47997506",
  FARMS: {
    masterchefv2
  },
};
